import Vue from 'vue'
import Loading from './Loading'
import SspActionButton from './SspActionButton'
import SspSaveForm from './SspSaveForm'

Vue.component('Loading', Loading)
Vue.component('SspActionButton', SspActionButton)
Vue.component('SspSaveForm', SspSaveForm)



// WEBPACK FOOTER //
// ./src/components/global/register-globals.js